import { render, staticRenderFns } from "./notificationBox.vue?vue&type=template&id=7209077c&scoped=true&"
import script from "./notificationBox.vue?vue&type=script&lang=js&"
export * from "./notificationBox.vue?vue&type=script&lang=js&"
import style0 from "./notificationBox.vue?vue&type=style&index=0&id=7209077c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7209077c",
  null
  
)

export default component.exports